export const faqs = [
  {
    q: "网报吃瓜的信息是从哪里来的？",
    a: "以官方公开发布的内容为准，包括政府部门通报、企业官方声明、执法部门通报等。对尚未有官方发声的事件，会单独标注「暂无官方回应」，不做主观推断。",
  },
  {
    q: "为什么有的时间线只有一条节点？",
    a: "说明该事件目前仅有一方发声，或后续进展尚未公开。页面会在更新时间上体现最近一次核对时间，出现新进展会补充节点。",
  },
  {
    q: "「阶段性进展」和「最终结论」有什么区别？",
    a: "阶段性进展指调查或整改仍在进行中的公开说明，不代表最终认定；最终结论会以官方通报的表述为准。两者会在时间线上以不同标签区分。",
  },
  {
    q: "如果我发现内容有误或者漏掉了官方通报怎么办？",
    a: "可以通过「联系与纠错」页面提交，附上官方原文链接与发布日期。核实后会在 24 小时内更正，并在时间线上标注修改时间。",
  },
  {
    q: "时间线会不会因为后续发展而被删改？",
    a: "不会覆盖删除。新进展以新增节点的方式追加，旧的节点保留原样，修改时间会同步更新，方便对照前后变化。",
  },
  {
    q: "转载这里的整理内容需要注意什么？",
    a: "欢迎注明来源后转载。涉及官方原文的表述请以原始发布为准，不要删改发布主体与时间信息。",
  },
];

export const mythItems = [
  {
    id: "m1",
    rumor: "今晚起全城停水 72 小时，请提前储水",
    truth: "仅青槐区两条支线管网分时段检修，涉及 3 个小区，全市其他区域供水正常。",
    actor: "云溪自来水公司",
    date: "2026-08-28",
    status: "已辟谣",
    eventId: "water-outage-rumor",
  },
  {
    id: "m2",
    rumor: "校门口有陌生人拉扯学生书包，家长务必接送",
    truth: "监控未发现拉扯行为，系路人问路时距离较近被误认，双方已见面消除误会。",
    actor: "云溪市公安局青槐分局",
    date: "2026-08-21",
    status: "已结案",
    eventId: "school-stranger-rumor",
  },
  {
    id: "m3",
    rumor: "网红景点封闭改造半年，已预约门票全部作废",
    truth: "仅西线两段步道阶段性检修，实行分时预约，已预约门票全部有效。",
    actor: "云溪市文化和旅游局",
    date: "2026-07-06",
    status: "已辟谣",
    eventId: "scenic-closure-rumor",
  },
  {
    id: "m4",
    rumor: "某零食代糖含量超标数倍，长期食用有风险",
    truth: "品牌方称出厂检验与标签一致，同批次留样已送第三方机构复检，报告待公布。",
    actor: "甜研社",
    date: "2026-08-31",
    status: "调查中",
    eventId: "sugar-free-snack",
  },
  {
    id: "m5",
    rumor: "快递驿站把滞留在网点的包裹集中丢弃",
    truth: "为无面单待处理件因分拣误判集中存放，已重新核验，九成以上找回派送。",
    actor: "顺捷驿站总部",
    date: "2026-07-24",
    status: "已通报",
    eventId: "express-parcel",
  },
  {
    id: "m6",
    rumor: "景区一份蛋炒饭卖 128 元，明码标价形同虚设",
    truth: "市监局检查 12 家档口，初步未发现该菜品，涉事档口餐具与视频不符，仍在核查。",
    actor: "云溪市市场监督管理局",
    date: "2026-09-09",
    status: "调查中",
    eventId: "cat-ear-mountain-price",
  },
];